import { platform, isMerchant } from '@/env'
import bus from './bus'
import { checkPermission, checkAuth } from '../../../plugins/authDirective'
import moment from 'moment'
export { bus, checkPermission }
import { Modal } from 'ant-design-vue'

import { isArray } from 'lodash'

export const checkArray = (data) => {
  return isArray(data)
}

export const checkForbidCrossVariantDisabled = (sourceVariantList, targetVariantList) => {
  // 逻辑补充 - 同一combo 不能跨variant group选择SKU
  return sourceVariantList?.some((source) => {
    return !targetVariantList?.some((target) => {
      return source.variant_value_id === target.variant_value_id
    })
  })
}

export const getComboBindListByFlat = (standaloneSkuList) => {
  const selectComboList = (standaloneSkuList || []).reduce((acc, item) => {
    const sku = {
      label: `${item.sku_id}-${item.sku_name}`,
      value: item.sku_id
    }

    // 查找是否已存在相同的 activity
    let activity = acc.find((act) => act.value === item.activity_id)
    if (!activity) {
      // 如果 activity 不存在，创建新的 activity
      activity = {
        label: `${item.activity_id}-${item.activity_name}`,
        value: item.activity_id,
        children: []
      }
      acc.push(activity)
    }

    // 在当前 activity 中查找是否已存在相同的 package
    let pkg = activity.children.find((p) => p.value === item.package_id)
    if (!pkg) {
      // 如果 package 不存在，创建新的 package
      pkg = {
        label: `${item.package_id}-${item.package_name}`,
        value: item.package_id,
        children: []
      }
      activity.children.push(pkg)
    }
    if (!pkg.children.find((s) => s.value === sku.value)) {
      // 将 sku 添加到 package 的 children 中
      pkg.children.push(sku)
    }
    return acc
  }, [])
  return selectComboList
}

export const getMergeComboBindList = (targetList, mergeList) => {
  const bindList = _.cloneDeep(targetList || [])
  const selectComboList = _.cloneDeep(mergeList || [])
  // 合并 selectComboList 到 bindList（按 activity_id、package_id、sku_id 维度）
  selectComboList.forEach((selectActivity) => {
    // 查找 bindList 中是否已存在相同的 activity
    let bindActivity = bindList.find((act) => act.value === selectActivity.value)

    if (!bindActivity) {
      // 如果 activity 不存在，直接添加整个 activity
      bindList.push(selectActivity)
    } else {
      // 如果 activity 存在，检查其下的 packages
      selectActivity.children.forEach((selectPkg) => {
        let bindPkg = bindActivity.children.find((pkg) => pkg.value === selectPkg.value)

        if (!bindPkg) {
          // 如果 package 不存在，直接添加整个 package
          bindActivity.children.push(selectPkg)
        } else {
          // 如果 package 存在，检查其下的 skus
          selectPkg.children.forEach((selectSku) => {
            let bindSku = bindPkg.children.find((sku) => sku.value === selectSku.value)

            if (!bindSku) {
              // 如果 sku 不存在，添加 sku
              bindPkg.children.push(selectSku)
            }
          })
        }
      })
    }
  })
  return bindList
}

const admin_const = require('@/admin_const')
// const URI = require('urijs')
// import store from '../store'
// const package_main = require("../package/package_main.js");
const lang_conf = require('lang_conf')

const lowerPlatForm = platform.toLowerCase()

const Flang2Blang = lang_conf.getLangObj('B_LANG', 'F_LANG')
export function getFlang2Blang(blang) {
  return Flang2Blang[blang] || ''
}
export const currencyAllList = admin_const.SUPPORT_CURRENCY_SYMBO.map((v) => ({
  label: v[0],
  value: v[0],
  symbol: v[1]
}))
export const getCurrencySymbol = (value) => {
  let obj = currencyAllList.find((o) => o.value === value) || {}
  return obj.symbol
}
export function getRoleKeysData(arr, roleStr, options) {
  if (!roleStr) return arr
  let opt = _.merge(
    {
      roleStr,
      roleKeys: 'roleKeys'
    },
    options
  )
  return arr.filter((item, i, data) => {
    let rks = item[opt.roleKeys]
    if (typeof rks === 'function') {
      rks = rks(item, i, data, opt.roleStr)
    } else if (getType(rks) === 'Object') {
      rks = rks.handler(item, i, data, opt.roleStr)
    }
    if (typeof rks === 'boolean') return rks
    if (!rks || (Array.isArray(rks) && !rks.length)) return true
    if (typeof rks === 'string') {
      rks = [rks]
    }
    let isTrue = false
    if (Array.isArray(opt.roleStr)) {
      for (let k in rks) {
        if (opt.roleStr.includes(rks[k])) {
          isTrue = true
          break
        }
      }
    } else {
      isTrue = rks.includes(opt.roleStr)
    }
    return isTrue
  })
}
export function getPlatformRoleKey() {
  // BDAuditPage  = "bd_audit"
  // MerchantPage = "merchant"
  // AdminPage    = "admin" // am
  // EMPage       = "em"
  let roleKey = 'merchant'
  if (isMerchant) {
    // MERCHANT ENV
  } else {
    // ADMIN ENV
    let adminRoles = ['bd_audit', 'admin']
    roleKey = adminRoles.includes(getUrlQuery('page_from')) ? getUrlQuery('page_from') : 'admin'
  }
  return roleKey
}
// SEO 高级权限，控制 TTD SEO 入口与页面访问
export const ACT_SEO_MASTER_CODE = 'experience/act/activity_seo_master'

export function hasActSeoPermission() {
  // merchant 平台不下发该权限，保持原有行为不变
  if (isMerchant) {
    return true
  }

  return checkPermission(ACT_SEO_MASTER_CODE)
}

export function getAdminRole() {
  let VIEW_CODE = 'experience/act/activity_admin_view'
  let AM_CODE = 'experience/act/activity_am_edit'
  let EM_CODE = 'experience/act/activity_em_edit'
  let is_am = checkPermission(AM_CODE)
  let is_em = checkPermission(EM_CODE)
  let is_view_admin = checkPermission(VIEW_CODE) //true 可以AM,EM列表任意切换，按钮权限
  let obj = {
    is_am,
    is_em,
    is_view_admin
  }
  return obj
}
export function getPlatformAuthKeys() {
  // BDAuditPage  = "bd_audit"
  // MerchantPage = "merchant"
  // AdminPage    = "admin" // am
  // EMPage       = "em"
  let roleKeys = []
  if (isMerchant) {
    // MERCHANT ENV
    roleKeys.push('merchant')
  } else if (getUrlQuery('page_from') === 'bd_audit') {
    // ADMIN ENV
    roleKeys.push('bd_audit') //
  } else {
    let obj = getAdminRole()
    if (obj.is_view_admin) {
      roleKeys.push(...['admin', 'em'])
    } else {
      obj.is_am && roleKeys.push('admin')
      obj.is_em && roleKeys.push('em')
    }
  }
  return roleKeys
}

export function initFilterLan(lang_created) {
  if (!Array.isArray(lang_created) || !lang_created.length) {
    console.warn('Warning : No available language for current activity!!')
    return []
  }

  let url = new URL(location.href)
  let search = new URLSearchParams(location.search)
  let refLang = getRefLang()
  let editLang = getEditLang()

  if (!lang_created.includes(editLang)) {
    editLang = lang_created[0]
    search.set('lang', editLang)
  }
  if (!lang_created.includes(refLang) || editLang === refLang) {
    refLang = ''
    search.set('ref', refLang)
  }
  search.has('ref') || search.set('ref', refLang)
  search.has('lang') || search.set('lang', editLang)
  url.search = search
  window.history.replaceState(null, null, url)

  return refLang && editLang !== refLang ? [editLang, refLang] : [editLang]
}

export const parse2id = (val, defVal = undefined) => {
  let num = parseInt(val)
  return num && num == val ? num : defVal
}

export const newOpenWin = (href, target = '_blank') => {
  let a = document.createElement('a')
  a.target = target
  a.href = href
  let e = document.createEvent('MouseEvents')
  e.initEvent('click', true, true)
  a.dispatchEvent(e)
}

export const mergeIf = (condition, data) => {
  return condition ? data : []
}

export const validatorDefault = (rule, value, callback) => {
  if (rule.required && (value === '' || undefined === value)) {
    callback(new Error(__('package_error_mandatory')))
  } else {
    callback()
  }
}
export const clearNull = (data) => {
  return Object.entries(data).reduce(
    (acc, [k, v]) => ({
      ...acc,
      ...(v !== null
        ? {
            [k]: v
          }
        : {})
    }),
    {}
  )
}

export const broadcastDisabled = function (componentName, callback = null) {
  componentName = _.flatten([componentName])
  this.$children.forEach((child) => {
    let name = _.get(child, '$options._componentTag', null)
    if (componentName.includes(name)) {
      // vue props warn
      child.disabled = true

      if (typeof callback === 'function') {
        callback({
          data: child
        })
      }

      // let $el = child.$el
      // $el.setAttribute('disabled', 'disabled')
      // $el.classList.add('is-disabled')
    } else {
      broadcastDisabled.apply(child, [componentName].concat([callback]))
    }
  })
}

export const setScrollTop = function (scrollTop) {
  if (document.documentElement && document.documentElement.scrollTop) {
    document.documentElement.scrollTop = scrollTop
  } else if (document.body) {
    document.body.scrollTop = scrollTop
  } else {
    return false
  }
  return true
}

export const getScrollTop = function () {
  let scrollTop = 0
  if (document.documentElement && document.documentElement.scrollTop) {
    scrollTop = document.documentElement.scrollTop
  } else if (document.body) {
    scrollTop = document.body.scrollTop
  }
  return scrollTop
}
export const scrollElError = (ele, option) => {
  let el = ele || document.querySelector('.has-error') || document.querySelector('.common-has-error')
  el &&
    el.scrollIntoView(
      option || {
        behavior: 'smooth',
        block: 'center'
      }
    )

  el = null
}
export const getCurrentLocal = (
  allData,
  { type, field, langField = 'language', valField = 'value', defaultVal = 'Please input' } = {}
) => {
  let data = _.get(allData, `${type}.config.${field}`, [])
  let current = _.find(data, {
    [langField]: lang_conf.getLangObj('F_LANG', 'B_LANG')[KLK_LANG]
  })
  return (current && current[valField]) || defaultVal
}
export const getAllEditLang = ({ requiredEn = false } = {}) => {
  let common = [getEditLang(), getRefLang()].filter((item) => item)

  if (requiredEn) {
    return [...new Set([...common, 'en_US'])]
  }

  return [...new Set(common)]
}

export const UUID_KEY = 'uuid'

export const getUuid = (prefix = 'uuid') => {
  return (
    `${prefix}-` +
    (+new Date()).toString(32).substring(0, 4) +
    '-' +
    Math.random().toString(32).substring(2, 6)
  )
}

export const getType = (value) => {
  return Object.prototype.toString.call(value).slice(8, -1)
}
export const getParamsKey = (params = {}, arr = [], options = {}) => {
  let obj = {}
  let defOpt = {
    paramsKey: 'paramsKey',
    valueKey: 'value',
    transform: {
      // Array: (arr) => {
      //   return arr.join(',')
      // }
    }
  }
  let opt = _.merge({}, defOpt, options)
  let { paramsKey, valueKey, transform } = opt
  const getType = (value) => {
    return Object.prototype.toString.call(value).slice(8, -1)
  }
  for (let k in params) {
    for (let i in arr) {
      let item = arr[i]
      if (item[paramsKey] === k) {
        let val = item[valueKey]
        obj[k] = getType(val) in transform ? transform[getType(val)](val) : val
      }
    }
  }
  return obj
}
export const parsePlatform = (str) => {
  return str.replace(/\{\{([^}]+)\}\}/g, (...args) => {
    return args[1] === 'platform' ? lowerPlatForm : args[1]
  })
}
export const parseApiUrl = (obj) => {
  let retObj = {}
  for (let k in obj) {
    retObj[k] = getType(obj[k]) === 'Object' ? parseApiUrl(obj[k]) : parsePlatform(obj[k])
  }
  return retObj
}
export const parseStr1 = (str = '', obj) => {
  return str.replace(/\{([^}]+)\}/g, (...args) => {
    return obj[args[1]]
  })
}
export const parseStr = (str = '', obj) => {
  return str.replace(/\{\{([^}]+)\}\}/g, (...args) => {
    return obj[args[1]]
  })
}
export const isCacheTime = ({ maxAge, cacheTime }) => {
  // 缓存时间比较：maxAge缓存时长，cpmTime记录时间
  if (!maxAge || !cacheTime) return false
  let time = new Date().getTime()
  return cacheTime + maxAge > time
}
export const getLocalStorage = (key) => {
  let val = window.localStorage.getItem(key)
  try {
    val = JSON.parse(val)
  } catch (error) {
    //
  }
  return val
}
export const setLocalStorage = (key, val) => {
  if (val !== null && typeof val === 'object') {
    window.localStorage.setItem(key, JSON.stringify(val))
  } else {
    window.localStorage.setItem(key, val)
  }
}

const loadCloudinary = () => {
  const s = document.createElement('script')
  //可以考虑用v2版本ui好看些 https://widget.cloudinary.com/v2.0/global/all.js;
  s.src = 'https://widget.cloudinary.com/v2.0/global/all.js'
  s.type = 'text/javascript'
  document.head.appendChild(s)
}

if (typeof window !== 'undefined') {
  loadCloudinary()
}

export const validB_LANG = (language, back = true) => {
  if (language && !lang_conf.getLangArray('B_LANG').includes(language)) {
    alert('Invalid language')
    back && window.history.back(-1)
  }

  return language
}

export const getLangTitle = (language) => {
  if (validB_LANG(language)) {
    return lang_conf.getLangObj('B_LANG', 'LANG_TITLE')[language]
  }
  return ''
}

export const getEditLang = () => validB_LANG(new URLSearchParams(location.search).get('lang') || 'en_US')

export const getRefLang = () => validB_LANG(new URLSearchParams(location.search).get('ref') || '')

export const getUrlQuery = (key) => new URLSearchParams(location.search).get(key) || ''

export const getBLanguage = () => {
  return lang_conf.getLangObj('F_LANG', 'B_LANG')[KLK_LANG] || 'en_US'
}

export const bestMatchLang = (nameLiteral, langLiteral, array) => {
  // multilauguage array ==> single lang string  #Octave
  if (_.isEmpty(array)) {
    return ''
  }

  return _.get(array.find((v) => v[langLiteral] == getEditLang()) || array[0], nameLiteral, '')
}

export const matchLang = (nameLiteral, langLiteral, array, lang) => {
  // multilauguage array ==> single lang string  #Octave
  if (_.isEmpty(array)) {
    return ''
  }

  return _.get(
    array.find((v) => v[langLiteral] == lang),
    nameLiteral,
    ''
  )
}

export const formatThousands = (n, formatter = ',') => {
  const number = n.toString()
  // 如果价格中包含 ',' 则直接返回价格
  if (number.includes(',')) {
    return number
  }
  if (number.includes('.')) {
    const numberArray = number.split('.')
    return `${numberArray[0].replace(/(?=(?!(\b))(\d{3})+$)/g, formatter)}.${numberArray[1]}`
  }

  return number.replace(/(?=(?!(\b))(\d{3})+$)/g, formatter)
}

export const scrollFormErrorIntoView = () => {
  const errorDom = document.querySelector('.ant-form-item-control.has-error')

  errorDom?.scrollIntoView?.({
    behavior: 'smooth',
    block: 'center'
  })
}

export const addZero = (num) => {
  if (num < 10) {
    return '0' + num.toString()
  } else {
    return num
  }
}

export const round2Decimal = (str) => {
  if (typeof str !== 'string') {
    str = str.toString()
  }

  str = str.replace(/[^.\d]/g, '') //清除"数字"和"."以外的字符
  str = str.replace(/^\./g, '') //验证第一个字符是数字而不是.
  str = str.replace(/\.{2,}/g, '.') //只保留第一个. 清除多余的.
  str = str.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.') //只允许输入一个小数点
  str = str.replace(/^(-)*(\d+)\.(\d\d).*$/, '$1$2.$3') //只能输入两个小数

  return str
}

export const getTimeOffset = (time) => {
  const timeArr = time.split(':')
  return timeArr[0] * 3600 + timeArr[1] * 60
}

//根据成本和售卖价计算take rate
export const computeTR = (cost, base, exchangeRate) => {
  if (!exchangeRate) {
    return ''
  }
  if (cost !== '' && +cost !== 0 && base !== '' && +base !== 0) {
    let rate = (1 - (+cost * exchangeRate) / +base) * 100
    return rate.toFixed(2)
  } else if (cost !== '' && +cost === 0 && base !== '') {
    return '100'
  } else if (cost !== '' && +cost !== 0 && +base === 0 && base !== '') {
    return 'undefined'
  } else {
    return ''
  }
}
//设置利润率，调整售卖价
export const setTRAndGetBase = (cost, base, take_rate, exchangeRate) => {
  let res = {
    cost,
    base,
    take_rate
  }
  if (!exchangeRate) {
    return res
  }
  if (take_rate === 'undefined') {
    return res
  }
  if (take_rate >= 100) {
    if (base === '' || cost === '') {
      res.take_rate = ''
    } else {
      res.take_rate = computeTR(cost, base, exchangeRate)
    }
    return res
  }
  if (cost !== '' && take_rate !== '') {
    let price = (+cost * exchangeRate) / (1 - +take_rate / 100)
    if (price - +price.toFixed(2) >= 0.001) {
      res.base = (price + 0.01).toFixed(2)
    } else {
      res.base = price.toFixed(2)
    }
    return res
  }
  return res
}
//设置成本和利润率，调整售卖价
export const setCostAndGetBase = (cost, base, take_rate, exchangeRate) => {
  let res = {
    cost,
    base,
    take_rate
  }
  if (!exchangeRate) {
    return res
  }
  if (cost === '') {
    return res
  }
  if (typeof cost === 'string' && +cost === 0) {
    if (base !== '') {
      res.take_rate = 100
    }
    return res
  }
  if (+cost !== 0 && +take_rate === 100) {
    res.take_rate = ''
    res.selling = ''
    return res
  }
  if (base === '' || take_rate === '') {
    return res
  }
  if (take_rate === 'undefined') {
    return res
  } else {
    let price = (+cost * exchangeRate) / (1 - +take_rate / 100)
    if (price - +price.toFixed(2) >= 0.001) {
      res.base = (price + 0.01).toFixed(2)
    } else {
      res.base = price.toFixed(2)
    }
    return res
  }
}
export const provingTakeRate = (take_rate) => {
  let value = take_rate + ''
  let t = value.charAt(0)
  value = value.replace(/[^\d.]/g, '')
  value = value.replace(/^\./g, '')
  value = value.replace(/^0{2,}/g, '0')
  value = value.replace(/\.{2,}/g, '.')
  value = value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
  value = value.replace('-', '$#$').replace(/-/g, '').replace('$#$', '-')
  value = value.replace(/^(-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
  if (value.charAt(0) == 0 && parseInt(value) >= 1) {
    value = value.substring(1, value.length)
  }
  if (t == '-') {
    value = '-' + value
  }
  return value
}

export const pmsConfirm = function ({
  title = '',
  content = '',
  okText = __('44915'),
  cancelText = __('44916'),
  okType = 'primary',
  icon = 'info-circle',
  okButtonProps = null,
  customClassName = '',
  zIndex = 9999,
  okCountdown = 0,
  ...otherConf
} = {}) {
  return new Promise((resolve) => {
    let className = customClassName + (title ? '' : ' --title-is-empty')

    // okCountdown > 0 时，确定按钮在倒计时结束前禁用，文案追加剩余秒数
    let timer = null
    const buildOkButtonProps = (remain) => {
      const base = okButtonProps || {}
      return {
        ...base,
        props: {
          ...(base.props || {}),
          disabled: remain > 0
        }
      }
    }
    const buildOkText = (remain) => (remain > 0 ? `${okText} (${remain}s)` : okText)

    const modal = Modal.confirm({
      title,
      content,
      okText: okCountdown > 0 ? buildOkText(okCountdown) : okText,
      cancelText,
      okType,
      icon,
      okButtonProps: okCountdown > 0 ? buildOkButtonProps(okCountdown) : okButtonProps,
      class: className,
      zIndex,
      onOk() {
        clearInterval(timer)
        return resolve(true)
      },
      onCancel() {
        clearInterval(timer)
        return resolve(false)
      },
      ...otherConf
    })

    if (okCountdown > 0) {
      let remain = okCountdown
      timer = setInterval(() => {
        remain -= 1
        modal.update({
          okText: buildOkText(remain),
          okButtonProps: buildOkButtonProps(remain)
        })
        if (remain <= 0) {
          clearInterval(timer)
        }
      }, 1000)
    }
  })
}

// 0 是可，1 是不可
export const getEditLockValueByPath = ({
  path,
  defaultVal = { status: 0, tips: '' },
  data = {},
  sku_id = null,
  base_path = 'edit_lock'
} = {}) => {
  let res

  if (sku_id) {
    const currSku = _.find(_.get(data, 'skus', []), { sku_id })
    res = currSku ? _.get(currSku, `${base_path}.${path}`, defaultVal) : defaultVal
  } else {
    res = _.get(data, `package.${base_path}.${path}`, defaultVal)
  }

  res = _.cloneDeep(res)

  if (res.tips) {
    res.tips = _.get(data, `tips_map.${res.tips}.content`, 'Edit lock.')
  }

  return {
    ...res,
    status: !!res.status
  }
}

export const getPackageFresherLastDate = (data, sku_id) => {
  const currSku = _.find(_.get(data, 'skus', []), { sku_id })
  return currSku ? _.get(currSku, 'last_date', '') : ''
}

export const getComboNameI18ns = function () {
  const lang = getEditLang()
  const isEn = lang === 'en_US'
  const i18ns = isEn
    ? [
        {
          language: 'en_US',
          name: '',
          lock: false
        }
      ]
    : [
        {
          language: lang,
          name: '',
          lock: false
        },
        {
          language: 'en_US',
          name: '',
          lock: false
        }
      ]
  return i18ns
}
// 将hex颜色转成rgb
export const hexToRgba = (hex, opacity = 1) => {
  const red = parseInt('0x' + hex.slice(1, 3))
  const green = parseInt('0x' + hex.slice(3, 5))
  const blue = parseInt('0x' + hex.slice(5, 7))
  const RGBA = `rgba(${red}, ${green}, ${blue}, ${opacity})`
  return RGBA
}

export const getWordCountLimitDisabled = (disabled) => {
  // 解决 没有freetext编辑权限，但是字数超了，无法修改的问题
  // if (!checkAuth('actFreeTextEdit')) {
  //   return false
  // }

  return !disabled && !checkAuth('wordCountLimit')
}

export const getWordCountLimit = (wordList = [], language) => {
  // 有该权限则不限制输入文字长度
  if (checkAuth('wordCountLimit')) {
    return Infinity
  }
  const lang = language || getEditLang()
  const data = wordList.find((item) => item.language === lang)
  return data?.value ?? Infinity
}

export const getSuffixCount = (max, length) => {
  if (Infinity === max) {
    return length
  }
  return `${length}/${max}`
}
// attribute widget 专属
export const genUUID = (v, field = 'order') => `${v.id}_${v[field] || '0'}`

import xssFilters from 'xss-filters'
const commonmark = require('commonmark')
export const parseMarkdown = (text = '') => {
  if (!text) {
    return ''
  }

  text = text.replace(/javascript:/g, encodeURIComponent('javascript:'))
  const reader = new commonmark.Parser()
  const writer = new commonmark.HtmlRenderer()
  const parsed = reader.parse(xssFilters.inHTMLData(text)) // parsed is a 'Node' tree

  return writer.render(parsed)
}

export const getParentNode = (node, className = 'common-item', MAX_LAYER = 8) => {
  while (MAX_LAYER && node?.classList) {
    if (node.classList.contains(className)) {
      return node
    }

    MAX_LAYER--
    node = node.parentNode
  }

  return null
}

export function isLikeArray(arr1, arr2) {
  let isb = getType(arr1) === 'Array' && getType(arr1) === getType(arr2) && arr1.length === arr2.length
  if (isb) {
    isb = arr1.every((v1) => {
      return arr2.some((v2) => {
        return isLikeEqual(v1, v2)
      })
    })
  }
  return isb
}

export function isLikeObject(obj1, obj2) {
  let isb = getType(obj1) === 'Object' && getType(obj1) === getType(obj2)
  if (isb) {
    const list = Object.keys(obj1)
    if (list.length !== Object.keys(obj2).length) {
      isb = false
    } else {
      isb = list.every((key) => {
        return isLikeEqual(obj1[key], obj2[key])
      })
    }
  }
  return isb
}

export function isLikeEqual(v1, v2) {
  let isb
  switch (getType(v1)) {
    case 'Array':
      isb = isLikeArray(v1, v2)
      break
    case 'Object':
      isb = isLikeObject(v1, v2)
      break
    default:
      isb = v1 === v2
  }
  return isb
}

export const getCalculatedDate = (diff, type = 'days') => {
  const targetDate = moment().utcOffset('+08:00').add(diff, type)
  return {
    YYYY: targetDate.year(),
    MM: targetDate.month() + 1,
    DD: targetDate.date()
  }
}

export function getPromiseInterceptor() {
  let pmsResolve
  let pms = new Promise((resolve) => {
    pmsResolve = resolve
  })

  pms.done = function done() {
    pmsResolve()
  }

  return pms
}

// 获得时间跨度里的具体时间
export const getDateRangeValues = (dateRange) => {
  let [start, end] = _.cloneDeep(dateRange)
  // format value to moment instance
  start = typeof start === 'string' ? moment(start) : start
  end = typeof end === 'string' ? moment(end) : end

  let dateRangeValues = []
  while (start <= end) {
    dateRangeValues.push(start.format('YYYY-MM-DD'))
    start = start.add(1, 'days')
  }

  return dateRangeValues
}

const WEEKDAY_VALUES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
// 获得 startDate ~ 时间跨度里包含 weekday 数据（周日是0）
export const getExistWeekdayListByRange = (startDate, rangeLength, isValue = false) => {
  let values = [0, 1, 2, 3, 4, 5, 6]
  if (isValue) {
    values = [...WEEKDAY_VALUES]
  }

  const RangeDict = Array(2)
    .fill()
    .reduce((acc) => [...acc, ...values], [])

  const startDateDay = moment(startDate).day()
  let startVal = startDateDay
  if (isValue) {
    startVal = WEEKDAY_VALUES[startDateDay]
  }

  const index = RangeDict.findIndex((curr) => curr === startVal)

  return RangeDict.splice(index, Math.min(7, rangeLength))
}

// 解析 weekday 为 day（周日是0）
export const getWeekdayValueByDayIdx = (dayIdx) => {
  return WEEKDAY_VALUES[dayIdx] || ''
}

export const addEventListener = (target, eventType, cb, options = {}) => {
  if (target?.addEventListener) {
    target.addEventListener(eventType, cb, options)
  }

  return {
    target,
    remove() {
      if (target?.removeEventListener) {
        target.removeEventListener(eventType, cb)
      }
    }
  }
}

// 检测只有英文和特殊字符
export const onlyEnglishTexts = (string = '') => {
  const reg =
    /[^a-zA-Z0-9`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、®©™ª℡丨\s]/g
  return !reg.test(string)
}

export function scrollToAsync(offset) {
  return new Promise((resolve) => {
    const fixedOffset = +offset.toFixed()

    const onScroll = function () {
      if (window.scrollY === fixedOffset) {
        window.removeEventListener('scroll', onScroll)
        return resolve(true)
      }
    }

    window.addEventListener('scroll', onScroll)
    onScroll()
    window.scrollTo({
      top: offset,
      behavior: 'smooth'
    })
  })
}
